module.exports = __webpack_public_path__ + "img/Kizingo-toddler-spoons-for-baby-led-weaning.c942974c.png";